import { CourseCardCombinedProps } from './types';

const usePresenter = (props: CourseCardCombinedProps): CourseCardCombinedProps => {
  return props;
};

export default usePresenter;
